import React, {
  useState,
} from "react";

function CareerAI() {

  // ==========================
  // STATES
  // ==========================
  const [
    resumeFile,
    setResumeFile,
  ] = useState(null);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const [
    result,
    setResult,
  ] = useState("");

  // ==========================
  // ANALYZE CAREER
  // ==========================
  const analyzeCareer =
    async () => {

      // FILE CHECK
      if (!resumeFile) {

        alert(
          "Please upload resume."
        );

        return;
      }

      setLoading(true);

      setResult("");

      try {

        // ==========================
        // FORM DATA
        // ==========================
        const formData =
          new FormData();

        formData.append(
          "resume",
          resumeFile
        );

        // ==========================
        // API CALL
        // ==========================

   console.log("VEDAI NEW BUILD 999");

        const response =
  await fetch(
    "/api/career-analysis",
    {
      method: "POST",

      headers: {
        Accept: "application/json",
      },

      body: formData,
    }
  );

console.log(
  "FETCH RESPONSE:",
  response
);

        const data =
          await response.json();

        console.log(
          "CAREER AI RESPONSE:",
          data
        );

        // ==========================
        // SUCCESS
        // ==========================
        if (
          data.success &&
          data.reply
        ) {

          setResult(
            data.reply
          );

        }

        else {

          alert(
            data.error ||
            "Career analysis failed."
          );

        }

      }

      catch (error) {

        console.log(
          "CAREER AI ERROR:",
          error
        );

        alert(
          "Cannot connect to CareerAI server."
        );

      }

      setLoading(false);

    };

  return (

    <div
      style={{
        padding: "40px",
        background: "#0f172a",
        minHeight: "100vh",
        color: "white",
        fontFamily: "Arial",
      }}
    >

      {/* TITLE */}
      <h1
        style={{
          fontSize: "40px",
          marginBottom: "10px",
        }}
      >
        VedAI Career Intelligence
      </h1>

      <p
        style={{
          color: "#94a3b8",
          marginBottom: "30px",
        }}
      >
        Upload your resume and let
        VedAI analyze your best
        career path, business
        potential, salary growth,
        and future opportunities.
      </p>

      {/* UPLOAD */}
      <input
        type="file"
        accept=".pdf,.doc,.docx"
        onChange={(e) =>
          setResumeFile(
            e.target.files[0]
          )
        }
      />

      {/* BUTTON */}
      <div
        style={{
          marginTop: "20px",
        }}
      >

        <button
          onClick={
            analyzeCareer
          }
          style={{
            padding:
              "14px 28px",
            background:
              "#2563eb",
            color: "white",
            border: "none",
            borderRadius:
              "10px",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Analyze Career
        </button>

      </div>

      {/* LOADING */}
      {loading && (

        <div
          style={{
            marginTop: "30px",
          }}
        >
          VedAI is analyzing your career profile...
        </div>

      )}

      {/* RESULT */}
      {result && (

        <div
          style={{
            marginTop: "30px",
            background:
              "#1e293b",
            padding: "20px",
            borderRadius:
              "14px",
            whiteSpace:
              "pre-wrap",
          }}
        >
          {result}
        </div>

      )}

    </div>

  );

}

export default CareerAI;